import stockNotificationStatus from "./stock-notification";

export function handleWishlist() {
  const quickshopSelector =
    $("#quickshop.is-open").length > 0 ? "#quickshop.is-open" : "";

  if (
    $(`${quickshopSelector} .product-main`).length > 0 &&
    typeof Appmate.wk !== undefined
  ) {
    const variantId = $(`${quickshopSelector} .wishlist-button-container`).attr(
      "data-variant-id"
    );

    if (
      Appmate.wk.collection.items[0].products.filter(
        (product) =>
          product.selected_variant_id ==
          ((window.location.search.includes("variant") &&
            window.location.search.split("=")[1]) ||
            variantId)
      ).length > 0
    ) {
      $(`${quickshopSelector} .js-add-variant-wishlist span`).text(
        "Remove from Wishlist"
      );
      $(`${quickshopSelector} .js-add-variant-wishlist`).attr(
        "data-action",
        "remove"
      );

      $(`${quickshopSelector} .js-add-variant-wishlist`).addClass(
        "wishlist-button--active"
      );
      $(`${quickshopSelector} .js-wishlist-loaded`).show();
      $(`${quickshopSelector} .js-wishlist-loading`).hide();
    } else {
      $(`${quickshopSelector} .js-add-variant-wishlist span`).text(
        "Add to Wishlist"
      );
      $(`${quickshopSelector} .js-add-variant-wishlist`).removeClass(
        "wishlist-button--active"
      );
      $(`${quickshopSelector}.js-add-variant-wishlist`).attr(
        "data-action",
        "add"
      );

      $(`${quickshopSelector} .js-wishlist-loaded`).show();
      $(`${quickshopSelector} .js-wishlist-loading`).hide();
    }
  }
}

export function handleAddWishlist() {
  const quickshopSelector =
    $("#quickshop.is-open").length > 0 ? "#quickshop.is-open" : "";

  $(`${quickshopSelector} .js-add-variant-wishlist`).on("click", function () {
    const productId = $(`${quickshopSelector} .wishlist-button-container`).attr(
      "data-product-id"
    );
    const variantId = $(`${quickshopSelector} .wishlist-button-container`).attr(
      "data-variant-id"
    );

    if ($(this).attr("data-action") == "add") {
      Appmate.wk
        .addProduct(productId, variantId)
        .then(() => {
          $(`${quickshopSelector} .js-add-variant-wishlist span`).text(
            "Remove from Wishlist"
          );
          $(`${quickshopSelector} .js-add-variant-wishlist`).addClass(
            "wishlist-button--active"
          );
          $(this).attr("data-action", "remove");
        })
        .catch((err) => console.error({ err }));
    } else {
      Appmate.wk
        .removeProduct(productId, variantId)
        .then(() => {
          $(`${quickshopSelector} .js-add-variant-wishlist span`).text(
            "Add to Wishlist"
          );
          $(`${quickshopSelector} .js-add-variant-wishlist`).removeClass(
            "wishlist-button--active"
          );
          $(this).attr("data-action", "add");
        })
        .catch((err) => console.error({ err }));
    }
  });
}

export function handleDefaultVariant(variantId = null) {
  const quickshopSelector =
    $("#quickshop.is-open").length > 0 ? "#quickshop.is-open" : "";
  if (window.location.search.length > 0 || variantId) {
    const defaultVariantId =
      variantId ||
      (window.location.search.includes("variant") &&
        window.location.search.split("=")[1]);
    let defaultValue = "";

    if (defaultVariantId.length > 0) {
      const selectedVariantValue = defaultVariantId;
      $(`${quickshopSelector} .js-main-select option`).each((i, elem) => {
        if ($(elem).val() == defaultVariantId) {
          $(elem).attr("selected", true);
          defaultValue = $(elem).attr("data-variant-options");
        } else {
          $(elem).attr("selected", false);
        }
      });

      $(`${quickshopSelector} .js-product-prices`)
        .find(`.js-product-price-${selectedVariantValue}`)
        .removeClass("hidden")
        .siblings()
        .addClass("hidden");

      $(`${quickshopSelector} .js-variant-quantities`)
        .find(`.js-variant-quantity-${selectedVariantValue}`)
        .removeClass("hidden")
        .siblings()
        .addClass("hidden");

      $(`${quickshopSelector} .js-selected-options`).val(defaultValue);
    }
  }
}

export default function changeVariant() {
  const quickshopSelector =
    $("#quickshop.is-open").length > 0 ? "#quickshop.is-open" : "";
  const selectedOptions = $(`${quickshopSelector} .js-selected-options`).val();
  const $mainSelect = $(`${quickshopSelector} .js-main-select`);
  const $selectedVariant = $mainSelect.find(
    `[data-variant-options="${selectedOptions}"]`
  );

  const selectedVariantValue = $selectedVariant.val();
  const $productPrices = $(`${quickshopSelector} .js-product-prices`);
  const $variantQuantity = $(`${quickshopSelector} .js-variant-quantities`);
  const $wishlistVariant = $(`${quickshopSelector} .wishlist-button-container`);

  if ($selectedVariant.attr("disabled") === undefined) {
    buttonStates("default");
    stockStatus("in-stock");
  } else {
    buttonStates("notify");
    stockStatus("sold-out");
  }

  if ($("#quickshop.is-open").length > 0) {
    const quickshopLink = $("#quickshop-link").prop("href").split("=")[0];
    $("#quickshop-link").prop(
      "href",
      `${quickshopLink}=${selectedVariantValue}`
    );
    $mainSelect.val(selectedVariantValue);
  }

  $productPrices
    .find(`.js-product-price-${selectedVariantValue}`)
    .removeClass("hidden")
    .siblings()
    .addClass("hidden");

  stockNotificationStatus();

  const $stockLength = $(
    `.stock-notification.js-variant-quantity-${selectedVariantValue}`
  ).length;

  if ($stockLength > 0) {
    $variantQuantity
      .find(`.stock-notification.js-variant-quantity-${selectedVariantValue}`)
      .removeClass("hidden")
      .siblings()
      .addClass("hidden");
  } else {
    $('[class="js-variant-quantities"]')
      .find(`.stock-notification`)
      .addClass("hidden");
  }

  $variantQuantity
    .find(`.js-ajax-add.js-variant-quantity-${selectedVariantValue}`)
    .removeClass("hidden")
    .siblings()
    .addClass("hidden");

  $wishlistVariant.attr("data-variant-id", `${selectedVariantValue}`);

  if (
    Appmate.wk.collection.items[0].products.filter(
      (product) => product.selected_variant_id == selectedVariantValue
    ).length === 0
  ) {
    $(`${quickshopSelector} .js-add-variant-wishlist span`).text(
      "Add to Wishlist"
    );
    $(`${quickshopSelector} .js-add-variant-wishlist`).removeClass(
      "wishlist-button--active"
    );
    $(`${quickshopSelector} .js-add-variant-wishlist`).attr(
      "data-action",
      "add"
    );
  } else {
    $(`${quickshopSelector} .js-add-variant-wishlist span`).text(
      "Remove From Wishlist"
    );
    $(`${quickshopSelector} .js-add-variant-wishlist`).addClass(
      "wishlist-button--active"
    );
    $(`${quickshopSelector} .js-add-variant-wishlist`).attr(
      "data-action",
      "remove"
    );
  }

  $(`${quickshopSelector} .product__body .js-ajax-add`).each((i, item) => {
    if (!$(item).hasClass("hidden") && $(item).text().includes("Pre Order")) {
      $(
        `${quickshopSelector} .product__body .drawer__product-preorder--product`
      ).removeClass("hidden");
      return false;
    } else {
      $(
        `${quickshopSelector} .product__body .drawer__product-preorder--product`
      ).addClass("hidden");
    }
  });
}

function buttonStates(state) {
  const quickshopSelector =
    $("#quickshop.is-open").length > 0 ? "#quickshop.is-open" : "";
  const $productSubmitButton = $(`${quickshopSelector} .btn-product`);

  switch (state) {
    case "notify":
      $productSubmitButton.addClass("js-notify-me");
      break;

    default:
      $productSubmitButton.removeClass("js-notify-me");
      break;
  }
}

function stockStatus(status) {
  const quickshopSelector =
    $("#quickshop.is-open").length > 0 ? "#quickshop.is-open" : "";
  const $stockStatus = $(`${quickshopSelector} .js-stock-status`);

  switch (status) {
    case "sold-out":
      $stockStatus.text($stockStatus.data("sold-out"));
      break;

    default:
      $stockStatus.text($stockStatus.data("in-stock"));
      break;
  }

  $(".drawer__product-preorder--product").removeClass("hidden");
}

if ($(".template-product")) {
  $(window).on("load", function (event) {
    handleWishlist();
  });
  handleAddWishlist();
  handleDefaultVariant();
}
